import TYPES from './types';
import { put, post } from 'utils/api';
import { successHandler } from 'common/utils/notifications';
import { updateTableRow, resetTableRowUpdate } from 'store/tables/lists/actions';

export const updateCpForm = params => dispatch => {
  const { id, table, ...rest } = params;
  dispatch({ type: TYPES.UPDATE_CP_FORM.START, payload: { params } });
  dispatch(updateTableRow({ data: params, table }));

  return put(`/cp-forms/${id}`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.UPDATE_CP_FORM.SUCCESS, payload: response.data });
      dispatch(updateTableRow({ data: response.data.data, table }));
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));

      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.UPDATE_CP_FORM.ERROR, payload: { response: error, params } });
      dispatch(resetTableRowUpdate({ data: params, table }));
      return error;
    });
};

export const createCpForm = params => dispatch => {
  const { table, ...rest } = params;
  dispatch({ type: TYPES.CREATE_CP_FORM.START, payload: { params } });

  return post(`/cp-forms`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.CREATE_CP_FORM.SUCCESS, payload: response.data });
      dispatch(successHandler({ title: 'Success!', message: 'Created CP-Form successfully' }));

      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.CREATE_CP_FORM.ERROR, payload: { response: error, params } });
      return error;
    });
};
